import { render, staticRenderFns } from "./InformationAboutTicket.vue?vue&type=template&id=63260708"
import script from "./InformationAboutTicket.vue?vue&type=script&lang=js"
export * from "./InformationAboutTicket.vue?vue&type=script&lang=js"
import style0 from "./InformationAboutTicket.vue?vue&type=style&index=0&id=63260708&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63260708')) {
      api.createRecord('63260708', component.options)
    } else {
      api.reload('63260708', component.options)
    }
    module.hot.accept("./InformationAboutTicket.vue?vue&type=template&id=63260708", function () {
      api.rerender('63260708', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Product/InformationAboutTicket.vue"
export default component.exports